/**
* @name APP parvulo
* @description
* # name controller --> modalEvaluationController
* # As Controller --> modalEvaluation														
*/
export default class modalEvaluationController {

    constructor($scope, $state, evaluationsServices,$rootScope,$modalInstance,UserInfoConstant,ngNotify, SERVICE_URL_CONSTANT, variableAEnviar) {
	    this.$scope = $scope
	    this.$state = $state
	    this.ngNotify = ngNotify
	    this.$rootScope = $rootScope
		this.services = evaluationsServices.services
		this.baseUrl = SERVICE_URL_CONSTANT
		this.$modalInstance = $modalInstance
		this.typeEvaluations = []
		this.$scope.detailsStudentsGrades ={
			enableFiltering: true
		}
		this.data = variableAEnviar.data
		this.indicatorId = variableAEnviar.indicatorId
		this.indicatorName = variableAEnviar.indicatorName
		this.perioId = variableAEnviar.perioId
		this.levelId = variableAEnviar.levelId
		this.$scope.detailsStudentsGrades.data = this.data

	    this.tableInitializeMethod()
		this.$scope.UserInfoConstant = UserInfoConstant
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.main()
			}
		})
    }

	main() {
		this.params = {
			concept_id: this.conceptId,
			indicator_id: this.indicatorId,
			period_id: this.perioId,
			level_id: this.levelId
		}

		this.getTypeEvaluations()
		this.getTypesGrades()
	}

	getStudents() {
		this.services.getEvaluations(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.$scope.detailsStudentsGrades.data = this.setAllDataStudents(dataReturn.results)
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getTypeEvaluations() {
		this.services.getTypeEvaluations(this.params).$promise.then((dataReturn) => {
			this.getStudents()
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.typeEvaluations = dataReturn.results
			}
		}, (err) => {
			this.getStudents()
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getTypesGrades() {
		this.services.getTypesGrades(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.typesGrades = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	setAllDataStudents(students) {
		return students.map(student => {
			return {
				studentId: student.id_code,
				ds_name: student.ds_name,
				ds_last_name: student.ds_last_name,
				first_eval: student.first_eval,
				first_date: student.first_date,
				first_grade: student.first_grade,
				first_update: 0,
				second_eval: student.second_eval,
				second_date: student.second_date,
				second_grade: student.second_grade,
				second_update: 0,
				third_eval: student.third_eval,
				third_date: student.third_date,
				third_grade: student.third_grade,
				third_update: 0,
				type_evaluations: this.typeEvaluations	
			}
		})
	}

	onStudentGradeStatusChange(student, option, type_grade) {
		if(!student.studentId) {
			this.ngNotify.set('Indique estudiante','warn')
			return
		}

		let params  = { 
			type_evaluation_id   : option,
			types_grades_id : type_grade,
			student_id   : student.studentId,
			user_id : this.user_id,
			concept_id: this.conceptId,
			indicator_id: this.indicatorId,
			period_id: this.perioId,
			level_id: this.levelId
		}

		this.services.saveEvaluations(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado la Evaluación correctamente','success');
				this.getStudents()
			}else{
				this.getStudents()
				this.ngNotify.set('Error con servicio check request','error');
			}
		}, (err) => {
			this.getStudents()
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de evaluación ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
		})
	}

	onChangeStudentGradeStatusChange(student, columna) {
		if (columna === 1){
			student.first_update = 1
			this.onStudentGradeStatusDelete(student, null, 1)
		}

		if (columna === 2){
			student.second_update = 1
			this.onStudentGradeStatusDelete(student, null, 2)
		}

		if (columna === 3){
			student.third_update = 1
			this.onStudentGradeStatusDelete(student, null, 3)
		}
	}

	onStudentGradeStatusDelete(student, option, type_grade) {
		if(!student.studentId) {
			this.ngNotify.set('Indique estudiante','warn')
			return
		}

		let params  = { 
			type_evaluation_id   : option,
			types_grades_id : type_grade,
			student_id   : student.studentId,
			user_id : this.user_id,
			concept_id: this.conceptId,
			indicator_id: this.indicatorId,
			period_id: this.perioId,
			level_id: this.levelId
		}

		this.services.deleteEvaluations(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha eliminado la Evaluación correctamente','success');
				this.getStudents()
			}else{
				this.getStudents()
				this.ngNotify.set('Error con servicio check request','error');
			}
		}, (err) => {
			this.getStudents()
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('No se ha podido editar la Evaluaciòn','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
		})
	}

	tableInitializeMethod() {
		this.$scope.detailsStudentsGrades.columnDefs = [
			{	field: 'ds_name', displayName: 'Nombres', headerCellClass : 'text-center', },
			{	field: 'ds_last_name', displayName: 'Apellidos', headerCellClass : 'text-center', },
			{	field: 'first_eval',
					displayName: 'Diagnostico',
					headerCellClass : 'text-center',
					width: '15%',
					cellTemplate    : `	<div class="center-xy text-center">
											<span class="badge badge-pill m-r-xs bg-dark" ng-if="row.entity.first_eval !== null && row.entity.first_eval === 1 && row.entity.first_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 1)">
												{{ 'Por Lograr' }}
											</span>
											<span class="badge badge-pill m-r-xs bg-info" ng-if="row.entity.first_eval !== null && row.entity.first_eval === 2 && row.entity.first_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 1)">
												{{ 'Medio Logrado' }}
											</span>
											<span class="badge badge-pill m-r-xs bg-success" ng-if="row.entity.first_eval !== null && row.entity.first_eval === 3 && row.entity.first_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 1)">
												{{ 'Logrado' }}
											</span>
											<div class="row" ng-if="row.entity.first_eval === null  || row.entity.first_update === 1">
												<div class="col-sm-4 radio-wrapper center-xy text-center">
													<input type="radio" name="radioGroup" value="3" ng-model="row.entity.first_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 3, 1)">
													<span>L</span>
												</div>
												<div class="col-sm-4 radio-wrapper center-xy text-center">
													<input type="radio" name="radioGroup" value="2" ng-model="row.entity.first_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 2, 1)">
													<span>M/L</span>
												</div>
												<div class="col-sm-4 radio-wrapper center-xy text-center">
													<input type="radio" name="radioGroup" value="1" ng-model="row.entity.first_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 1, 1)">
													<span>P/L</span>
												</div>
											</div>
										</div>`, },
			{	field: 'second_eval',
				displayName: 'Formativa',
				headerCellClass : 'text-center',
				width: '15%',
				cellTemplate    :`	<div class="center-xy text-center">
										<span class="badge badge-pill m-r-xs bg-dark" ng-if="row.entity.second_eval !== null && row.entity.second_eval === 1 && row.entity.second_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 2)">
											{{ 'Por Lograr' }}
										</span>
										<span class="badge badge-pill m-r-xs bg-info" ng-if="row.entity.second_eval !== null && row.entity.second_eval === 2 && row.entity.second_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 2)">
											{{ 'Medio Logrado' }}
										</span>
										<span class="badge badge-pill m-r-xs bg-success" ng-if="row.entity.second_eval !== null && row.entity.second_eval === 3 && row.entity.second_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 2)">
											{{ 'Logrado' }}
										</span>
										<div class="row" ng-if="row.entity.second_eval === null || row.entity.second_update === 1" >
											<div class="col-sm-4 radio-wrapper center-xy text-center">
												<input type="radio" name="radioGroup" value="3" ng-model="row.entity.second_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 3, 2)">
												<span>L</span>
											</div>
											<div class="col-sm-4 radio-wrapper center-xy text-center">
												<input type="radio" name="radioGroup" value="2" ng-model="row.entity.second_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 2, 2)">
												<span>M/L</span>
											</div>
											<div class="col-sm-4 radio-wrapper center-xy text-center">
												<input type="radio" name="radioGroup" value="1" ng-model="row.entity.second_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 1, 2)">
												<span>P/L</span>
											</div>
										</div>
									</div>`, },
			{	field: 'third_eval',
				displayName: 'Sumativa',
				headerCellClass : 'text-center',
				width: '15%',
				cellTemplate    :`	<div class="center-xy text-center">
										<span class="badge badge-pill m-r-xs bg-dark" ng-if="row.entity.third_eval !== null && row.entity.third_eval === 1 && row.entity.third_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 3)">
											{{ 'Por Lograr' }}
										</span>
										<span class="badge badge-pill m-r-xs bg-info" ng-if="row.entity.third_eval !== null && row.entity.third_eval === 2 && row.entity.third_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 3)">
											{{ 'Medio Logrado' }}
										</span>
										<span class="badge badge-pill m-r-xs bg-success" ng-if="row.entity.third_eval !== null && row.entity.third_eval === 3 && row.entity.third_update === 0" ng-click ="grid.appScope.modalEvaluation.onChangeStudentGradeStatusChange(row.entity, 3)">
											{{ 'Logrado' }}
										</span>
										<div class="row" ng-if="row.entity.third_eval === null || row.entity.third_update === 1" " >
											<div class="col-sm-4 radio-wrapper center-xy text-center">
												<input type="radio" name="radioGroup" value="3" ng-model="row.entity.third_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 3, 3)">
												<span>L</span>
											</div>
											<div class="col-sm-4 radio-wrapper center-xy text-center">
												<input type="radio" name="radioGroup" value="2" ng-model="row.entity.third_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 2, 3)">
												<span>M/L</span>
											</div>
											<div class="col-sm-4 radio-wrapper center-xy text-center">
												<input type="radio" name="radioGroup" value="1" ng-model="row.entity.third_eval" ng-change ="grid.appScope.modalEvaluation.onStudentGradeStatusChange(row.entity, 1, 3)">
												<span>P/L</span>
											</div>
										</div>
									</div>`, }
		]
	}

	cancel() {
		this.$state.reload('app.minorHalf')
		this.$modalInstance.dismiss('chao');
	}
  }

  modalEvaluationController.$inject = ['$scope', '$state', 'evaluationsServices','$rootScope','$modalInstance','UserInfoConstant','ngNotify', 'SERVICE_URL_CONSTANT', 'variableAEnviar'];



// WEBPACK FOOTER //
// ./src/app/course-front/modal-evaluation-students/modalEvaluationController.js